import { Grid, Stack, TextField, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { TransportSelectionProps } from '@yard/app/models/host/transport-selection.model'
import { observer } from 'mobx-react-lite'
import { FC, ReactNode } from 'react'
import { CarrierVisitDirectionAutoComplete } from '../AutoCompletes/CarrierVisitDirectionAutoComplete/CarrierVisitDirectionAutoComplete'
import { AllocationRuleDestinationsForm } from './components/organisms/AllocationRuleDestinationsForm'
import { AllocationRuleFacetsSubForm } from './components/organisms/AllocationRuleFacetsForm'
import { AllocationRuleFormStore } from './stores/allocation-rule.form-store'

type Props = {
  formStore: AllocationRuleFormStore
  disableDirectionChange?: boolean
  disableTransportSelection?: boolean
  hideCarrierFields?: boolean
  transportSelection?: (props: TransportSelectionProps) => ReactNode
  companyAutoComplete: (props: any) => ReactNode
  locationCodeAutoComplete: (props: any) => ReactNode
  imoClassAutoComplete: (props: any) => ReactNode
}

export const AllocationRuleForm: FC<Props> = observer(props => {
  const {
    formStore,
    disableDirectionChange,
    disableTransportSelection,
    hideCarrierFields,
    transportSelection,
    imoClassAutoComplete,
  } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Stack component='form' noValidate autoComplete='off' gap={theme.customSpacing.l}>
      <Stack flexDirection='row' justifyContent='space-between' alignItems='center'>
        <Typography variant='subtitle1'>
          {t('allocationRuleDetails', 'Allocation Rule details')}
        </Typography>
      </Stack>

      <Grid container spacing={2}>
        <Grid size={hideCarrierFields ? 12 : 8}>
          <TextField
            {...formStore.name.props}
            fullWidth
            label={`${t('name', 'Name')}`}
            required
            error={!!formStore.name.error}
            helperText={
              formStore.name.error
                ? t(formStore.name.error)
                : t('pleaseMakeSureItsAUniqueField', "Please make sure it's a unique {field}", {
                    field: t('name', 'name'),
                  })
            }
          />
        </Grid>
        {!hideCarrierFields && (
          <Grid size={4}>
            <CarrierVisitDirectionAutoComplete
              disabled={disableDirectionChange || disableTransportSelection}
              defaultValue={formStore.facets.direction.value ?? undefined}
              onChange={value => {
                formStore.facets.direction.setValue(value)
              }}
            />
          </Grid>
        )}
      </Grid>

      <AllocationRuleFacetsSubForm
        {...props}
        transportSelection={transportSelection}
        disableTransportSelection={disableTransportSelection}
        imoClassAutoComplete={imoClassAutoComplete}
      />

      <AllocationRuleDestinationsForm
        formStore={formStore}
        destinations={formStore.sortedDestinations}
      />
    </Stack>
  )
})
